import './App.css'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import RenterDetail from './pages/RenterDetail';
import Scanner from './pages/Scanner';
import CheckAuth from './Auths/CheckUser';
import StaffProfile from './pages/StaffProfile';
import List from './pages/List';
import QrPage from './NewPages/QrPage';
import SewaClientEdit from './components/Qr/UpdateSewaCustomer';
import PromiseToPay from "./pages/PromiseToPay";
import RemarksPage from "./pages/RemarksPage";
import PaymentCollectionReport from "./pages/PaymentCollectionReport";
import TunggakanPage from "./pages/TunggakanPage";

function App() {

  const token = localStorage.getItem('token')

  if (!token) {
    return (

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
        </Routes>
      </BrowserRouter>
    )

  } else {
    return (

      <BrowserRouter>
        <CheckAuth>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path='/scanner' element={<QrPage />} />
            <Route path='/sewa-client-update/:bil' element={<SewaClientEdit />} />
            <Route path='/payment-report' element={<PaymentCollectionReport />} />
            <Route path='/staff-detail' element={< StaffProfile />} />
            <Route path="/login" element={<Login />} />
            <Route path="/renter-detail" element={<RenterDetail />} />
            <Route path='/qrscanner' element={<Scanner />} />
            <Route path='/list' element={<List />} />
            <Route path='/profile' element={<StaffProfile />} />
            <Route path='/remarks/:bil' element={<RemarksPage />} />
            <Route path="/promise-to-pay" element={<PromiseToPay />} />
            <Route path="/tunggakan" element={<TunggakanPage />} />
          </Routes>
        </CheckAuth>
      </BrowserRouter>


    );
  }
}

export default App;
